import { getIsInitialised } from '@wetransfer/transfer/modules/analytics/vendors/amplitude';
import { getVariant } from '@wetransfer/transfer/modules/experiments';

export default class TeamDiscoveryExperiment {
  static key = 'team-discovery-experiment';

  static variations = {
    control: 'control',
    'show-team-discovery-experiment': 'show-team-discovery-experiment',
  };

  static isControl(): boolean {
    return getVariant(this.key) === this.variations.control;
  }

  static isShowTeamDiscoveryExperiment(): boolean {
    return (
      this.currentVariant() ===
      this.variations['show-team-discovery-experiment']
    );
  }

  static currentVariant(): string {
    return getVariant(this.key, this.variations.control) as string;
  }

  static isInitialised(): boolean {
    return getIsInitialised();
  }
}
